/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function() {

    // Shop Money Format
    window.formatThePrice = function(data) {
      let moneyFormat = theme.moneyFormat;
      let price = data.toFixed(2);
      let formattedPrice = moneyFormat.replace(`{{amount}}`, price);
      return formattedPrice;
    }
  
    // ============== START: Loop Subscription widget append code ======================
    
    function updateCalculatedPrice() {
      var interval = setInterval(function () {
        var priceElement = document.querySelector('[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price');
        if (priceElement) {
          clearInterval(interval);
          var priceText = priceElement.textContent;
          var price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
          if (isNaN(price)) return;
  
          var buttons = document.querySelectorAll('.loop-widget-sp-button');
          if (buttons.length === 0) return;
          
          buttons.forEach(function(button, index) {
            // Remove existing calculated span
            var existing = button.querySelector('.calculated-price');
            if (existing) existing.remove();
  
            let days = 30; // Default to 30 days
            let buttonText = button.textContent; // Store original text
            
            if (buttonText.toLowerCase().includes("month")) {
                days = 30; 
            } else {
                var daysMatch = buttonText.match(/(\d+)/);
                if (daysMatch) {
                    days = parseInt(daysMatch[1]);
                }
            }
            if (isNaN(days) || days === 0) return;
      
            var pricePerDay = price / days;
            var span = document.createElement('span');
            span.className = 'calculated-price';
            span.textContent = window.formatThePrice(pricePerDay) + ` p/day`;
            
            button.innerHTML = buttonText.replace(/(\d+ days)/i, ' <br> $1'); // Insert <br> before "30 days"
      
            button.appendChild(span);

            // Append badge only to the second button (index 1)
            if (index === 1) {
              appendBadge(button, "Best seller");
            } else if (index === 3) {
              appendBadge(button, "Best value");
            }
          });
        }                     
      }, 100);
    }

    function appendBadge(button, label) {
      if (button.querySelector('.sub_var_badge_block')) return;
    
      const badge = document.createElement('div');
      badge.className = 'sub_var_badge_block';
      badge.innerHTML = `<span class="sub_var_badge">${label}</span>`;
    
      button.appendChild(badge);
    }
    
    var intervalCheck = setInterval(function () {
      if (document.querySelectorAll(".loop-widget-container").length) {
        clearInterval(intervalCheck);
        updateCalculatedPrice();
      }
    }, 100);

    
    document.querySelectorAll(".product__content .selector-wrapper fieldset input").forEach(input => {
      input.addEventListener('change', function () {
        updateCalculatedPrice(); // Call your function on variant change
      });
    });

    

    function appendSubscriptionTerms() {
      const buttonContainer = document.querySelector(".loop-widget-sp-button-container");
    
      if (!buttonContainer) return;
    
      // Create the container
      const subscriptionInfo = document.createElement("div");
      subscriptionInfo.className = "subscription-terms-box"; // optional class
      subscriptionInfo.innerHTML = `
        <div style="border-top: 1px solid #ccc; padding-top: 10px; margin-top: 10px; display: flex; justify-content: space-between; font-size: 14px;">
          <span><strong>Subscription Terms & Benefits</strong></span>
          <a href="#" style="text-decoration: underline;">Learn more</a>
        </div>
      `;
      
      // Append below the target container
      buttonContainer.insertAdjacentElement("afterend", subscriptionInfo);
    }

     var interval = setInterval(function () {
        var loopContainer = document.querySelector('.loop-widget-sp-button-selector-wrapper');
        if (loopContainer) {
          clearInterval(interval);

          // Create the container
          const subscriptionInfo = document.createElement("div");
          subscriptionInfo.className = "subscription-terms-box"; // optional class
          subscriptionInfo.innerHTML = `
            <div class="subscription-terms">
              <div class="subscription-terms-wrapper">
                <span class="subscription-terms-title">Subscription Terms & Benefits</span>
                <span class="subscription-terms-toggle-button">
                  <span class="sub-learn-more">Learn more</span>
                  <span class="sub-close-icon" style="display:none;">Close</span>
                </span>
              </div>
               <div class="subscription-terms-content" style="display:none; margin-top: 10px;">
                <ul>
                  <li>Free shipping</li>
                  <li>Cancel, Pause Anytime.</li>
                  <li>Exclusive Subscriber Discounts.</li>
                  <li>Never Run Out of Your Essential Supplements.</li>
                </ul>
              </div>
            </div>
          `;
        
          // Append below the target container
          loopContainer.insertAdjacentElement("afterend", subscriptionInfo);
      
          const parentBox = document.querySelector('.subscription-terms');
          const toggleClick = parentBox.querySelector('.subscription-terms-toggle-button');
          
          toggleClick.addEventListener("click", function () {
            parentBox.classList.toggle("active");
          });

        }                    
     }, 100);
    // ============== END: Loop Subscription widget append code ======================
  
    
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

    
})();






  
        
  
